<template>
  <div class="flex justify-content-center align-items-center gap-2">
    <Button
      v-tooltip="funnelStepName"
      class="inline-block white-space-nowrap overflow-hidden text-overflow-ellipsis p-button-secondary p-button-outlined"
      :class="{ 'active-step': isActive }"
      style="max-width: 150px;"
      @click="handleSelectFunnel(funnelStep.idSend)"
    >
      {{ funnelStepName || '' }}
    </Button>
    <div v-if="hasNextStep">
      <i class="fa-light fa-chevron-right" />
    </div>
    <DataViewerFunnelStep
      v-if="nextStep"
      :key="nextStep.idSend"
      :funnel-step="nextStep"
      :funnel-data="funnelData"
      :current-id-send="currentIdSend"
      @select-funnel="handleChildSelectFunnel"
    />
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  computed,
  PropType,
} from 'vue';

import Button from 'primevue/button';
import Tooltip from 'primevue/tooltip';

interface FunnelStepData {
  idSend: number;
  date: string;
  channel: number;
  templateName: string;
}

export default defineComponent({
  name: 'DataViewerFunnelStep',

  components: {
    Button,
  },

  directives: {
    tooltip: Tooltip,
  },

  props: {
    funnelStep: {
      type: Object as PropType<FunnelStepData>,
      required: true,
    },

    funnelData: {
      type: Array as PropType<FunnelStepData[]>,
      required: true,
    },

    currentIdSend: {
      type: Number,
      required: true,
    },
  },

  emits: ['select-funnel'],

  setup(props, { emit }) {
    const funnelStepName = computed(() => props.funnelStep.templateName);

    const currentIndex = computed(() => props.funnelData.findIndex(
      (step) => step.idSend === props.funnelStep.idSend,
    ));

    const nextStep = computed(() => {
      const index = currentIndex.value;
      if (index === -1 || index >= props.funnelData.length - 1) {
        return null;
      }
      return props.funnelData[index + 1];
    });

    const hasNextStep = computed(() => nextStep.value !== null);

    const handleSelectFunnel = (idSend: number | undefined) => {
      if (idSend !== undefined && idSend !== props.currentIdSend) {
        emit('select-funnel', idSend);
      }
    };

    const handleChildSelectFunnel = (idSend: number) => {
      emit('select-funnel', idSend);
    };

    const isActive = computed(() => props.funnelStep.idSend === props.currentIdSend);

    return {
      nextStep,
      isActive,
      funnelStepName,
      hasNextStep,
      handleSelectFunnel,
      handleChildSelectFunnel,
    };
  },
});
</script>

<style lang="scss" scoped>
.active-step {
  background-color: rgba(96, 125, 139, 0.2) !important;
  border: 1px solid !important;
}
</style>
